import { Action } from '../../actions';
import { StoreState } from '../../reducers';
import { Dispatch } from 'react-redux';
import LocalStorageManager from '../../utils/localStorage/manager';

export enum DownloadAllPopupActionKeys {
	CLOSE = '@@DownloadAllPopup/CLOSE',
}

export type DownloadAllPopupAction = CloseAction;

interface CloseAction extends Action {
	type: DownloadAllPopupActionKeys.CLOSE;
}

export const closeDownloadAllPopup = (dontAskAgain: boolean = false) =>
	(dispatch: Dispatch<StoreState>): void => {

		if (dontAskAgain) {
			LocalStorageManager.setDownloadPopupDontAskAgain();
		}
		dispatch({
			type: DownloadAllPopupActionKeys.CLOSE,
		});
	};

export const closeDownloadAllPopupIfNeeded = () => (dispatch: Dispatch<StoreState>): void => {
	const downloadPopupDontAskAgain = LocalStorageManager.getDownloadPopupDontAskAgain();
	if (downloadPopupDontAskAgain) {
		dispatch(closeDownloadAllPopup());
	}
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadAllPopup/actions.ts